<template>
    <div class="signature_widget">
        <button v-if="!pdfLoading" class="toolbarButton hiddenMediumView primary-btn save_btn" :disabled="saveLoading" @click="savePdf">Save</button>

        <div class="header-section">
            <!-- authorized signatories drop down when petitioner wants to sign -->
             <label v-if="checkProperty(authSignatoriesList, 'length') > 0" class="authorized_sign_lbl">Authorized Signatory</label>
            <vs-dropdown v-if="checkProperty(authSignatoriesList, 'length') > 0">
                <a class="flex items-center">
                    <div class="drop-down-content">
                        {{ checkProperty(currentSigner, 'name') ?  checkProperty(currentSigner, 'name') : 'Select Authorized Signatory'}} 
                    </div>
                    <i class="material-icons">arrow_drop_down</i>
                </a>
                <vs-dropdown-menu class="caseno-dropdown signature_dropdown">
                    <vs-dropdown-item v-for="(signer, index) in authSignatoriesList" :key="index"
                        @click="handleSignerSelection(signer)"
                        :class="checkProperty(currentSigner, '_id') == checkProperty(signer, '_id') ? 'selected_signer' : ''"
                        >
                        {{ checkProperty(signer, 'name')  }}
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <div v-if="true" class="upload_sign_widget">

                <template v-if="true">
                    <div class="uploadsec_wrap uploadsec_wrap_v2">
                        <customCropImage @input="updateCropData" :vvas="'Electronic Signature'" :display="true"
                            :cid="'ElectronicDocuments'" :formscope="''" :fieldName="'ElectronicDocuments'"
                            :required="true" />
                            <label>{{ (signatures && checkProperty(signatures, 'length') > 0) ? 'Update Signature' : 'Add Signature' }}</label>
                    </div>
                </template>
               
            </div>
            <div v-if="signatures && checkProperty(signatures, 'length') > 0"
                 @dragstart="onFirstDrag(signatures[0], $event)"
                  class="pdf_e_signature"> 
                <img class="sign-option" :src="signatures[0].path" />
            </div>
            
        </div>
        <div ref="pdfContainer" class="pdf-container" v-if="!pdfLoadingError">

            <div v-for="(page, index) in totalPages" :key="index" :id="'page-container-' + index"
                :class="`pdf-page-container ${computeCursorStyle}`"
                draggable="true"
                @dragover.prevent
                @drop="onSignDrop($event, index)"
                >
                <canvas :id="'page-' + index" class="pdf-canvas"> </canvas>
                <template >
                    <div class="dragable_item" :key="sig.signId" v-for="(sig, i) in sigsOnPages[index]"
                        @dragstart="handleDragStart($event, sig, i, index)" draggable="true" :class="computeCursorStyle"
                        :style="{ position: 'absolute', 'top': sigsOnPages[index][i]['y'] + 'px', 'left': sigsOnPages[index][i]['x'] + 'px' }">
                        <div class="sign-container">
                            <img class="sign" :src="sig.path" />
                            <span class="remove" @click="removeSign(sig, index, i)">x</span>
                        </div>
                    </div>
                </template>

            </div>

        </div>
        <div class="pdf_error"  v-if="pdfLoadingError">
            <img src="@/assets/images/main/no-data.jpg"   />
            <p>{{ pdfLoadingError }}</p>
        </div>

    </div>

</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry.js';
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdfjs-dist/pdf.worker.min.js'
import draggable from 'vuedraggable';
import _ from 'lodash';
import uuid from 'random-uuid';
import customCropImage from './forms/fields/customCropImage.vue'

export default {
    components: {
        draggable,
        customCropImage
    },
    props: {
        pdfUrl: String,
        petition: Object
    },
    data() {
        return {
            signatures: [],
            pdfDoc: null,
            selectedSignature: null,
            totalPages: 0,
            currentPage: 0,
            sigsOnPages: [],
            dragStarted: false,
            offsetX: 0,
            offsetY: 0,
            currentSignatureIndex: '',
            uploadOriginalDocument:[],
            authSignatoriesList: [],
            showSignUpload: false,
            currentSigner: null,
            pdfLoading: true,
            saveLoading: false,
            initialOffsetX: 0,
            initialOffsetY: 0,
            pdfLoadingError: '',
        }
    },
    methods: {
        handleSignerSelection(signer){
            if(this.checkProperty(signer, 'signDocument') && this.checkProperty(signer, 'signDocument', 'length') > 0){
                this.signatures = signer.signDocument;
                this.currentSigner = signer;
                this.showSignUpload = false;
            }
            else{
                this.showSignUpload = true;
                this.signatures = new Array();
                this.currentSigner = signer;
            }
        },
        filameChenged(fileindex) {
            this.disable_uploadBtn = false;
            if (this.uploadOriginalDocument.length > 0) {
                _.forEach(this.uploadOriginalDocument, (fl, value) => {
                    let fname = fl.name;
                    fname = fname.trim();
                    if (!fname) {
                        this.disable_uploadBtn = true;
                    }
                });
            }
        },
        updateCropData(data) {
               this.uploadOriginalDocument.push(data);
               this.addSignToAuthSigner(data);
        },
        remove(item, data, filindex) {
            data.splice(filindex, 1);
            this.removeFileFromS3(item)
        },
        onDrag(event) {
            if (this.dragStarted) {
                if (this.currentSignatureIndex !== -1) {
                    const canvas = document.getElementById(`page-${this.currentPage}`);
                    const rect = canvas.getBoundingClientRect();

                    let newX = event.clientX - rect.left - this.offsetX;
                    let newY = event.clientY - rect.top - this.offsetY;

                    newX = Math.max(0, Math.min(newX, rect.width - 202));
                    newY = Math.max(0, Math.min(newY, rect.height - 52));

                    this.sigsOnPages[this.currentPage][this.currentSignatureIndex].x = newX;
                    this.sigsOnPages[this.currentPage][this.currentSignatureIndex].y = newY;

                    this.sigsOnPages[this.currentPage][this.currentSignatureIndex]["canvasWidth"] = rect.width;
                    this.sigsOnPages[this.currentPage][this.currentSignatureIndex]["canvasHeight"] = rect.height;
                }
            }
        },
        onDragEnd(event) {
            if (this.currentSignatureIndex !== -1) {
                const canvas = document.getElementById(`page-${this.currentPage}`);
                const rect = canvas.getBoundingClientRect();

                let newX = event.clientX - rect.left - this.offsetX;
                let newY = event.clientY - rect.top - this.offsetY;

                newX = Math.max(0, Math.min(newX, rect.width - 202));
                newY = Math.max(0, Math.min(newY, rect.height - 52));

                this.sigsOnPages[this.currentPage][this.currentSignatureIndex].x = newX;
                this.sigsOnPages[this.currentPage][this.currentSignatureIndex].y = newY;
                this.sigsOnPages[this.currentPage][this.currentSignatureIndex]["canvasWidth"] = rect.width;
                this.sigsOnPages[this.currentPage][this.currentSignatureIndex]["canvasHeight"] = rect.height;
            }
            this.dragStarted = false
            removeEventListener("mousemove", this.onDrag);
            removeEventListener("mouseup", this.onDragEnd);
        },
        handleDragStart(event, sign, index, pageNo) {
            addEventListener("mousemove", this.onDrag);
            addEventListener("mouseup", this.onDragEnd);
            this.dragStarted = true;
            this.currentSignatureIndex = index
            this.offsetX = event.clientX -  event.target.getBoundingClientRect().left;
            this.offsetY = event.clientY -  event.target.getBoundingClientRect().top;
            this.currentPage = pageNo;
         
        },
        adjustCanvasAndSignatures() {
            this.sigsOnPages.forEach((page, index) => {
                const canvas = document.getElementById(`page-${index}`);
                const rect = canvas.getBoundingClientRect();

                this.sigsOnPages[index].forEach((sig, signI) => {
                    this.sigsOnPages[index][signI].x = (sig.x / sig.canvasWidth) * rect.width;
                    this.sigsOnPages[index][signI].y = (sig.y / sig.canvasHeight) * rect.height;
                    this.sigsOnPages[index][signI].canvasWidth = rect.width;
                    this.sigsOnPages[index][signI].canvasHeight = rect.height;
                });

            });
        },
        async loadPdf(url) {
            const loadingTask = pdfjsLib.getDocument(url);
            // this.pdfDoc = await loadingTask.promise;

            loadingTask.promise.then(async (pdfDoc) => {
            this.pdfDoc = pdfDoc;
            this.totalPages = this.pdfDoc.numPages;
            this.pages = new Array(this.totalPages).fill(null);
            this.sigsOnPages = new Array(this.totalPages).fill([]).map(() => []);

            for (let pageIndex = 0; pageIndex < this.totalPages; pageIndex++) {
                const page = await this.pdfDoc.getPage(pageIndex + 1);

                const viewport = page.getViewport(2, 0, false);
                const canvas = document.getElementById('page-' + pageIndex);
                if (!canvas) {
                    return;
                }
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                const context = canvas.getContext('2d');
                if (!canvas) {
                    return;
                }
                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                try {
                    await page.render(renderContext).promise;
                } catch (error) {
                }
            }
            this.pdfLoading = false
            this.pdfLoadingError = ''
            window.addEventListener('resize', this.adjustCanvasAndSignatures);
        }, (error) => {
            this.pdfLoadingError = 'Failed to load document'
        })

        },
        onFirstDrag(signature, event) {
            this.selectedSignature = Object.assign(signature, {
                initialDrop: true
            });
            this.initialOffsetX = event.clientX - event.target.getBoundingClientRect().left;
            this.initialOffsetY = event.clientY - event.target.getBoundingClientRect().top;
            var mypage;
            if (this.totalPages) {
                if (this.$refs.pdfContainer.scrollTop / ((this.$refs.pdfContainer.scrollHeight - this.$refs.pdfContainer.offsetHeight) / this.totalPages)) {
                    mypage = this.totalPages == 1 ? 0 : Math.floor(this.$refs.pdfContainer.scrollTop / ((this.$refs.pdfContainer.scrollHeight - this.$refs.pdfContainer.offsetHeight) / this.totalPages));
                } else {
                    mypage = 0;
                }
                this.currentPage = mypage >= this.totalPages ? this.totalPages - 1 : mypage
            }
        },
        onSignDrop(event, pageNo) {
            if (this.checkProperty(this.selectedSignature, 'initialDrop')) {

                this.currentPage = pageNo;
                const containerRect = event.currentTarget.getBoundingClientRect();

                let dropX = event.clientX - this.initialOffsetX - (containerRect.left);
                let dropY = event.clientY - this.initialOffsetY - (containerRect.top);
                dropX = Math.max(0, Math.min(dropX, containerRect.width - 202));
                dropY = Math.max(0, Math.min(dropY, containerRect.height - 52));

                this.addSignatureToPage(dropX, dropY);
                this.selectedSignature.initialDrop = false;
            }
        },
        handleLoading(){
            this.saveLoading = !this.saveLoading;
            if(this.saveLoading){
                this.$vs.loading();
            }else{
                this.$vs.loading.close(); 
            }
        },
        async savePdf() {
            let finalPositions = new Array();
            this.sigsOnPages.forEach((page, index) => {
                this.sigsOnPages[index].forEach((sig, signI) => {
                    finalPositions.push({
                        page: index,
                        width: ((202/sig.canvasWidth) * 612),
                        height: ((52/sig.canvasHeight) * 792),
                        x: ((sig.x / sig.canvasWidth) * 612),
                        y: ((sig.y / sig.canvasHeight) * 792)
                    })
                  
                });

            });
            if(this.selectedSignature && this.checkProperty(finalPositions, 'length') > 0){
                this.handleLoading();
                this.$emit('saveSignPositions',finalPositions, this.selectedSignature, this.currentSigner);
            }
            else{
                this.showToster({ message: 'Please add signatures and try again.', isError: true });
            }
            
        },
        addSignatureToPage(x = 0, y = 0) {
            if (this.selectedSignature) {
                const canvas = document.getElementById(`page-${this.currentPage}`);
                const rect = canvas.getBoundingClientRect();

                this.sigsOnPages[this.currentPage].push({
                    x,
                    y,
                    path: this.selectedSignature.path,
                    pageIndex: this.currentPage,
                    canvasWidth: rect.width,
                    canvasHeight: rect.height,
                    signId: uuid()
                });
            }
        },
        removeSign(signature, pageIndex,index) {
            this.sigsOnPages[pageIndex].splice(index,1);
        },
        async initialLoadPdf() {
            await this.loadPdf(this.pdfUrl);
        },
        draggableStyles() { },
        getAuthSignatoriesList(){
            let payload = {
                matcher: {
                    "title": ""
                },
                page: 1,
                perpage: 1000000
            }
            this.$store.dispatch('getList',{"data": payload, "path": "/users/get-auth-signers"}).then((response) => {
              
                if(this.checkProperty(response, 'list') && this.checkProperty(response, 'list','length') > 0){
                    this.authSignatoriesList = response.list;
                    if(this.currentSigner){
                        this.prevSigner = _.filter(this.authSignatoriesList, (Asigner) => {
                            return (this.checkProperty(Asigner, '_id') == this.checkProperty(this.currentSigner, '_id') && (this.checkProperty(Asigner, 'signDocument', 'length')>0) )
                        })
                        if(this.checkProperty( this.prevSigner, 'length') > 0){
                            this.showSignUpload = false;
                            this.signatures = this.prevSigner[0].signDocument;
                        }
                    }else{
                        this.handleSignerSelection(this.authSignatoriesList[0])
                    }
                }
            })
            .catch((error) => {
                console.log(" error in getting auth signatories list ", error);
                // this.showToster({ message: error, isError: true });
            })
        },
        addSignToAuthSigner(signDocument){
            let payload = {
                signDocument 
            }
            if(this.getTenantTypeId == 1 && this.getUserRoleId == 50 ){
                // if law firm and petitioner logins
                payload['userType'] = 'Petitioner'
                payload['companyId'] = this.checkProperty(this.petition, 'companyDetails', '_id');
                payload['signatoryId'] = this.checkProperty(this.currentSigner, '_id');
            }
            else{
                // if signer or attorney
                payload['userId'] =  this.checkProperty(this.getUserData, 'userId');
                if(this.getUserRoleId == 12){
                    payload['userType'] = 'Signer'; 
                }
                else if(this.getUserRoleId == 6){
                    payload['userType'] = 'Attorney'; 
                }
            }
            this.$store.dispatch('addNewSignToAuthSigner',payload ).then((response) => {
                this.showToster({ message: response.message, isError: false });
                // this.getAuthSignatoriesList();
                this.getDiffUserSign();
            })
            .catch((error) => {
                this.showToster({ message: error, isError: true });
            })
        },
        getPetSignatures() {
            this.$store.dispatch('getCompanyDetails', { companyId: this.checkProperty(this.petition, 'companyDetails', '_id') }).then((response) => {
                if (response && this.checkProperty(response, 'signDocs', 'length') > 0) {
                    this.signatures = this.checkProperty(response, 'signDocs');
                    this.showSignUpload = false;
                }else{
                    this.showSignUpload = true;
                    this.signatures = new Array();
                }
            })
        },
        getUserSignatures() {
            this.$store.dispatch('getuserdetails', { userId: this.checkProperty(this.getUserData, 'userId') }).then((response) => {
                if (response && this.checkProperty(response, 'signDocs', 'length') > 0) {
                    this.signatures = this.checkProperty(response, 'signDocs');
                    this.showSignUpload = false;
                }else{
                    this.showSignUpload = true;
                    this.signatures = new Array();
                }
            });
        },
        getDiffUserSign(){
            if (this.getUserRoleId == 50 && this.getTenantTypeId == 1 ){
                this.getAuthSignatoriesList();
            }
            else if (this.getUserRoleId == 6 || (this.getUserRoleId == 12 && this.getTenantTypeId == 2)) {
                this.getUserSignatures()
                this.currentSigner = { 
                    name: this.checkProperty( this.getUserData, 'name'),
                    email:  this.checkProperty( this.getUserData, 'email'),
                    userId:  this.checkProperty( this.getUserData, 'userId'),
                    roleId:  this.checkProperty( this.getUserData, 'roleId'),
                    tenantId:  this.checkProperty( this.getUserData, 'tenantId')
                }; 
            }
            else if (this.getUserRoleId == 51) {
                //handle benificiary case
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.adjustCanvasAndSignatures);
    },
    mounted() {
        this.initialLoadPdf();
        this.getDiffUserSign();
    },
    computed: {
        computeCursorStyle(){
            return this.dragStarted ? 'dragging' : ''
        }
    }

}
</script>

<style scoped>
.draggablee {
    width: 100px;
    height: 100px;
    background-color: lightblue;
    cursor: pointer;
    position: absolute;
    z-index: 99;
}

.pdf-canvas {
    border: 1px solid black;
    width: 100%;
    height: auto;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.pdf-container {
    height: 80vh;
    overflow: scroll;
}

.header-section {
    position: sticky;
    top: 0;
    height: auto;
    width: 100%;
    background-color: #fafafa;
    z-index: 90000;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.caseno-dropdown {
    z-index: 99999991;
}

.sign {
    display: inline !important;
    margin: 0px 0px !important;
    width: 200px !important;
    height: 50px !important;
    position: absolute;
    z-index: 2000;
}

.sign-option {
    width: 200px;
    height: 50px;
}

.pdf-page-container {
    position: relative;
    margin-bottom: 20px;
}

.signature-dropdown {

    background-color: white;
    border: 1px solid #ccc;
    z-index: 99990;
}

.pdf-controls {
    margin: 10px 0;
}

.remove {
    z-index: 99999;
    position: relative;
}

.sign-container {
    border: 3px solid blue;
    background: #ffffff;
}

.sign-container img {
    position: static;
}
.dragging{
    cursor: move !important;
}
.primary-btn {
    min-width: 80px;
    height: 34px;
    border: 0px;
}
</style>